export const ancestorByData = (el, data) => {
	while ((el = el.parentElement) && !el.hasAttribute(data)) {}
	return el;
};

export const ancestorByClass = (el, cls) => {
	while ((el = el.parentElement) && !el.classList.contains(cls));
	return el;
};

export const ancestorBySelector = (el, selector) => {
	const all = document.querySelectorAll(selector);
	let current = el.parentNode;
	while (current && !collectionHas(all, current)) {
		current = current.parentNode;
	}
	return current !== null ? current : false;
};

function collectionHas(a, b) {
	//helper function (see below)
	for (let i = 0, len = a.length; i < len; i++) {
		if (a[i] == b) return true;
	}
	return false;
}
